import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import axiosInstance from 'utils/axiosUtil';
import { withRouter } from 'utils';
import { setChatbotState } from '../../store/actions/appActions' 
import { connect } from 'react-redux';
import routeUpdateState            from './updateStateRouter'; 
import { CLAIMS_RANGE_MSG } from 'utils/claimsRange';

const limitMessages = (messages, limit = 20) => messages.slice(-limit);
const cleanMessages = (messages, limit = 20) => messages.filter((msg) => !msg.widget || msg.widget !== 'customLoadingView').slice(-limit);

//const ActionProvider = ({ createChatBotMessage, setState, children, userid, messages, router }) => {
const ActionProvider = ({ dispatch, chatbotState, user, selectedClient, createChatBotMessage, setState, children, router }) => {
    
    // --- On FIRST mount, initialize chatbot state from Redux
    useEffect(() => {
        if (chatbotState && chatbotState.messages?.length) {
        setState((prev) => ({
            ...prev,
            ...chatbotState // messages, messageid, userid
        }));
        }
    }, []);

    useEffect(() => {
    const reduxMsgs = chatbotState?.messages || [];
    setState((prev) => {
        const localMsgs = prev.messages || [];
        const newOnes   = reduxMsgs.slice(localMsgs.length);   // may be empty
        return { ...prev, messages: [...localMsgs, ...newOnes] };
    });
}, [chatbotState?.messages]);
  
    // --- Always reflect the latest state: Prefer child state if present, else Redux
    const state = children?.props?.children?.props?.state || chatbotState || {};
    //const user = state.user;
    const messages = state.messages || [];
    let messageid = state.messageid;

    // --- Helper: sync messages/id/userid to Redux
    function syncChatbotState(nextMessages, nextMessageid = messageid, nextUser = user, nextClient = selectedClient) {
        setState((prev) => ({                  // keep the component copy fresh
        ...prev,
        messages:  nextMessages,
        messageid: nextMessageid,
        user:    nextUser
      }));
        
        dispatch(setChatbotState({
            messages: nextMessages,
            messageid: nextMessageid,
            user: nextUser,
            selectedClient: nextClient
        }));
    }



    const handleOther = async (message) => {
    
        if (!message || message.trim() === '') {
            console.warn('Empty message received, skipping processing.');
            return;
        }

        /* ──────────────────────────────────────────────────────────────
        *  Handle special command “Clear Chat”
        *  ─────────────────────────────────────────────────────────── */
        if (message && message.trim().toLowerCase() === 'clear chat') {

                
            const clearedMsg = createChatBotMessage('Conversation cleared. How can I help?', { loading:false });
            setState({ messages: [clearedMsg], messageid: null, user });
            dispatch(setChatbotState({ messages: [clearedMsg], messageid: null, user }));

            return;
        }

        /* ──────────────────────────────────────────────
        *  Handle special command “Close chat”
        *  ─────────────────────────────────────────── */

        if (message.trim().toLowerCase() === 'close chat') {

        /* 1. gracefully stop the audio session, if any */
        const audio = AudioConversation.getInstance();
        if (audio.isConversationStarted()) {
            await audio.endConversation();             // goodbye + shutdown
        }

        /* 2. perform the SAME reset we use for “clear chat” */
        const clearedMsg = createChatBotMessage(
            'Conversation cleared. How can I help?', { loading:false }
        );

        setState({ messages: [clearedMsg], messageid: null, user });
        dispatch(setChatbotState({ messages: [clearedMsg], messageid: null, user }));

        /* 3. tell DocChatBot to close the panel */
        window.dispatchEvent(new Event('close-chat'));

        return;                                       // stop further processing
        }
        messages.push({ role: 'user', content: message }); // Add user message to local state
        const localMessages = [...messages]; 

        const loadingId = `loading-${Math.random()}`; // Unique id in case of multiple loads
        const loadingMessage = createChatBotMessage('', {
            widget: 'customLoadingView',
            loadingId // Pass down so you can identify/remove it
        });

        dispatch(setChatbotState({
            messages: [...localMessages, loadingMessage],
            messageid: messageid,
            user: user,
            selectedClient: selectedClient
        }));

        setState((prev) => {
            return {
                ...prev,
                messages: limitMessages([...prev.messages, loadingMessage])
            };
        });

        let tempResponse;
        let updatedMessageId = messageid;

        try {
            // Filter out any previous loading messages from history
            let coreMessages = (localMessages || []).filter(
                (msg) => !msg.widget || msg.widget !== 'customLoadingView'
            );

            coreMessages = (coreMessages || []).map((msg) => ({
                role: msg.role === 'user' ? 'user' : 'assistant',
                //content: msg.message === '' ? (msg.payload?.content || '') : msg.message
                content: msg.message || msg.content || msg.payload?.content
            })).slice(-10);

            const devLine = { role:'developer', content: CLAIMS_RANGE_MSG };

            // NEW: permissions guard for admins
            const isAdmin = !!(user?.is_admin ?? user?.isAdmin);
            const devPerms = isAdmin
            ? {
            role: 'developer',
            content:
            'Important policy: The current user is an administrator. Administrators must not create or update Activity Notes. ' +
            'Never propose, attempt, or call any function/tool to create or update an Activity Note. ' +
            'Offer read-only help (e.g., viewing or navigating to notes) instead.'
            }
            : null;

            coreMessages = devPerms ? [devPerms, devLine, ...coreMessages] : [devLine, ...coreMessages];


            tempResponse = await axiosInstance.post('/AI', {
                question: message,
                user: user,
                messages: coreMessages,
                url: window.location.pathname ,
                previous_response_id: messageid,
                prompt: sessionStorage.getItem('system_prompt'),
                client_id: selectedClient,  
                audio_mode: false,
            });

            updatedMessageId = tempResponse.data?.id || messageid;

            
            /* refresh any cache slice the backend dirtied */
            routeUpdateState(
                tempResponse.data?.update_state,   
                dispatch,                          
                selectedClient    ,
                router                 
            );

        } catch (error) {
            console.error('Error fetching AI response:', error);
            return;
        } 
        
          let botMessage = null;
        if (tempResponse) {
            if (tempResponse.data.action) {
                const { action, arguments: args } = tempResponse.data;

                if (action === 'take_me_there') {
                    let targetUrl = args;

                    if (targetUrl && targetUrl.url) {
                        targetUrl = targetUrl.url;
                    }

                    if (targetUrl) {
                     
                        botMessage = createChatBotMessage(`Taking you to: ${targetUrl.path}`, { loading:false })


                        updatedMessageId = null;
                        
                       setState((prev) => {
                            const newMessages = cleanMessages([...prev.messages, botMessage]);

                            // keep Redux in-sync
                            syncChatbotState(newMessages, updatedMessageId);

                            // return the next React state
                            return {
                                ...prev,
                                messages:  newMessages,
                                messageid: updatedMessageId
                            };
                        });

                        router.navigate(targetUrl.path);
                    }
                } else if (action === 'error') {                    
                    botMessage = createChatBotMessage( tempResponse.data.output_text, { loading:false } )
                            

                    setState((prev) => {
                        const newMessages = cleanMessages([...prev.messages, botMessage]);

                        // keep Redux in-sync
                        syncChatbotState(newMessages,  null);

                        // return the next React state
                        return {
                            ...prev,
                            messages:  newMessages,
                            messageid: null
                        };
                    });
                        
                } else {
                    botMessage = createChatBotMessage(tempResponse.data.output_text, { loading:false })


                    setState((prev) => {
                        const newMessages = cleanMessages([...prev.messages, botMessage]);

                        // keep Redux in-sync
                        syncChatbotState(newMessages, updatedMessageId);

                        // return the next React state
                        return {
                            ...prev,
                            messages:  newMessages,
                            messageid: updatedMessageId
                        };
                    });
                }


                
            } else {
                botMessage = createChatBotMessage(tempResponse.data.output_text, { loading:false }) 


                setState((prev) => {
                    const newMessages = cleanMessages([...prev.messages, botMessage]);

                    // keep Redux in-sync
                    syncChatbotState(newMessages, updatedMessageId);

                    // return the next React state
                    return {
                        ...prev,
                        messages:  newMessages,
                        messageid: updatedMessageId
                    };
                });

            }
        }


        setTimeout(scrollLastUserMsgWhenReady, 500);
        
        return;

        //return {
          //  ...prev,
            //messageid: updatedMessageId,
            //messages: botMessage ? [...filteredMessages, botMessage] : filteredMessages
            
        

    };



    const scrollLastUserMsgWhenReady = () => {
        const msgContainer = document.querySelector('.react-chatbot-kit-chat-message-container');
        if (!msgContainer) return;
        //const userMessages = document.querySelectorAll('.react-chatbot-kit-chat-user-message');
        //const lastUserMsg = userMessages[userMessages.length - 1];
  
        //setTimeout(() => {
            //const botMessages = msgContainer.querySelectorAll('.react-chatbot-kit-chat-bot-message, .react-chatbot-kit-chat-user-message');
            const botMessages = msgContainer.querySelectorAll('.react-chatbot-kit-user-chat-message');
            const lastMsg = botMessages[botMessages.length - 1];        

            if (lastMsg) {
          //        requestAnimationFrame(() => {
                    lastMsg.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    // Then, scroll parent up by a bit, after the smooth scroll
                    setTimeout(() => {
                    const container = lastMsg.parentElement.parentElement; // or your specific scroll container
                    // Adjust the '30' to however much space you want (in px, roughly a "line")
                    container.scrollTop -= 20; 
                    }, 400); // Delay should roughly match your CSS scroll duration (400ms for smooth), or less for instant
                //});
            }
        //}, 1500); // Delay may be needed to wait for DOM update
    }

        return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    actions: {
                        handleOther
                    },
                })
            })}
        </div>
    )
}; 

ActionProvider.propTypes = {
    dispatch: PropTypes.func.isRequired,
    chatbotState: PropTypes.object,
    router: PropTypes.object,
    setState: PropTypes.func.isRequired,
    children: PropTypes.node,
    messages: PropTypes.array,
    config: PropTypes.object,
    allCounties: PropTypes.object,
    user: PropTypes.object,
    selectedClient: PropTypes.number,
    createChatBotMessage: PropTypes.func.isRequired,
    prevstate: PropTypes.object
  };

  const mapStateToProps = (state) => ({
    chatbotState: state.app.chatbot,
    user: state.user,
    selectedClient: state.app.selectedClient,
    allCounties  : state.counties   
    
});

export default connect(mapStateToProps)(withRouter(ActionProvider));
